import { render, staticRenderFns } from "./ProductImageSlider.vue?vue&type=template&id=526ee4b3&scoped=true"
import script from "./ProductImageSlider.vue?vue&type=script&lang=js"
export * from "./ProductImageSlider.vue?vue&type=script&lang=js"
import style0 from "./ProductImageSlider.vue?vue&type=style&index=0&id=526ee4b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526ee4b3",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fproduct-image-slider%2FProductImageSlider.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports